import { Component, ElementRef, Inject, Injector, HostListener } from "@angular/core";
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AppComponentBase } from "../../../services/AppComponentBase";
import { Product } from "../../../api/DixApiClient";
import { AppstoreSuccessComponent } from "../appstore-success-notification/appstore-success-notification.component";
import * as ShopifyBuy from "shopify-buy";
import { Utils } from "../../../utils";

@Component({
    selector: "modal-appproduct-buypopup",
    template: require('./appproduct-buypopup.component.html'),
    styles: [require('./appproduct-buypopup.component.css')]
})
export class appProductBuyPopup extends AppComponentBase {
    constructor(injector: Injector, public activeModal: NgbActiveModal) {
        super(injector);

        this.globaGridMode.appSuccessNotification.subscribe(l => {
            let product = this.workspace.producsList.filter(v => {
                return v.productId == l;
            })[0];

            if (this.workspace.lastPrId != l) {
                this.showSmallNotification(product.thumbnail);
                this.workspace.lastPrId = l;
            }
        });
        
        this.showLoader = true;
        this.webUrl = "";
    }

    private _checkoutError: boolean = false;
    public get checkoutError(): boolean {
        return this._checkoutError;
    }
    public set checkoutError(value: boolean) {
        this._checkoutError = value;
    }
    public buyAPI() {
        const client = ShopifyBuy.buildClient({
            domain: "premieretrade.myshopify.com",
            storefrontAccessToken: "56e74e782c7e24db7e6e37b31e62a06f"
        });

      
        // let allProduct:
        client.product
            .fetchAll()
            .then(products => {
                console.log(products);

                let ourProduct = products.filter(v => {
                    let t = v.variants[0] as any;
                    console.log(t.sku);
                    return t.sku == this.productSku;
                })[0];

                let productID = ourProduct.id;
                let variantID = ourProduct.variants[0].id;

                let t = client.checkout as any;

                let checkoutId = `CH_${Date.now()}_${Math.random()}`;

                let input = {
                    email: this.workspace.userName,
                    lineItems: [
                        {
                            variantId: variantID,
                            quantity: 1
                        }
                    ],
                    note: checkoutId,
                    customAttributes: [{ key: "MyKey", value: "MyValue" }]
                    // shippingAddress: {
                    //     "lastName": "Doe",
                    //     "firstName": "John",
                    //     "address1": "123 Test Street",
                    //     "province": "QC",
                    //     "country": "Canada",
                    //     "zip": "H3K0X2",
                    //     "city": "Montreal"
                    //   }
                };

                t.create(input).then((checkout: any) => {
                    console.log("ENDDATA");
                    let w = checkout as any;
                    console.log(checkout);
                    console.log(checkout.lineItems);
                    console.log(w.webUrl);
                    this.webUrl = w.webUrl;
                    console.log("------------");
                    this.windowheight = window.innerHeight - 50;


                    if(this.popupWindow==null)
                    {
                        this.workspace
                            .createOrUpdateOrder(
                                this.dataService.getSessionKey(),
                                this.workspace.userId,
                                this.productSku,

                                checkoutId,
                                checkout.webUrl,
                            JSON.stringify(checkout)
                            )
                            .then(response => {

                                // debugger;
                                console.log(response);

                               
                                if(response&&response.error==null)
                                {
                                    this.allowOpenAction = true;
                                    this.showLoader = false;
                                }
                               else
                               {
                                   this.showLoader = false;
                                   this.checkoutError = true
                               }
                              //   this.openPopup(this.webUrl, "", 700, height);
                                // this.checkPopupFocus();


                            });

                    }
                    else
                    {
                        this.popupWindow.focus();
                    }
                });
            })
            .catch(e => {
                this.showLoader = false;
                console.log(e);
            });
    }

    private _windowheight: number = 0;
    public get windowheight (): number {
        return this._windowheight;
    }
    public set windowheight ( value: number ) {
        this._windowheight = value;
    }

    private _allowOpenAction: boolean = false;
    public get allowOpenAction (): boolean {
        return this._allowOpenAction;
    }
    public set allowOpenAction ( value: boolean ) {
        this._allowOpenAction = value;
    }

    private _showLoader: boolean = false;
    public get showLoader(): boolean {
        return this._showLoader;
    }
    public set showLoader(value: boolean) {
        this._showLoader = value;
    }

    private _popupWindow: Window | null = null;
    public get popupWindow (): Window | null {
        return this._popupWindow;
    }
    public set popupWindow ( value: Window | null ) {
        this._popupWindow = value;
    }

    private _popupFocusTimeOut: any = null;
    public get popupFocusTimeOut (): any {
        return this._popupFocusTimeOut;
    }
    public set popupFocusTimeOut ( value: any ) {
        this._popupFocusTimeOut = value;
    }

    public checkPopupFocus()
    {
       clearTimeout(this.popupFocusTimeOut);

       this.popupFocusTimeOut = setTimeout(() => {
          
        

            try{
                
                if(this.popupWindow)
                console.log(this.popupWindow.window.closed);

            }catch(e)
            {
               // console.log("ERROR");
                this.activeModal.dismiss();
            }


           if(this.popupWindow)
           {
                this.popupWindow.focus();
                this.popupWindow.blur();
                this.popupWindow.window.focus()
                this.popupWindow.window.blur()

                console.log(this.popupWindow.window);
                console.log("this.popupWindow.window.closed");
                if(this.popupWindow.window)
                {
                     console.log(this.popupWindow.window.closed);
                    if(this.popupWindow.window.closed==true)
                    {
                        this.activeModal.dismiss();
                    }
                }
            //    else
            //    {
            //      //  console.log("123");
            //    }

                if(this.popupWindow.window!=null)
                {
                      this.checkPopupFocus();
                }
                else
                {
                    this.activeModal.dismiss();
                }
           }
       }, 100);

    }



    public openPopup(myURL: any, title: any, myWidth: any, myHeight: any) {

        if(this.popupWindow==null)
        {
              this.popupWindow = Utils.openPopupWithHandle(myURL, title, myWidth, myHeight);
              this.showLoader = true;
              this.checkPopupFocus();
        }
        else
        {
            this.popupWindow.focus();
        }

        // if(this.popupWindow)
        // this.popupWindow.onbeforeunload = function(e){
        //   // this.
        //   alert("CLOSED")
        // };
    }

    private _webUrl: string = "";
    public get webUrl(): string {
        return this._webUrl;
    }
    public set webUrl(value: string) {
        this._webUrl = value;
    }

    public showSmallNotification(v: any) {
        let config = Object.assign(this.toastr.toastrConfig, {});
        config.timeOut = 6000;
        config.progressBar = true;
        config.closeButton = true;
        config.toastComponent = AppstoreSuccessComponent;

        let params: {} = {
            error: false,
            image: v
        };

        this.toastr.show(JSON.stringify(params), "", config);
    }

    private _productSku: string = "";
    public get productSku(): string {
        return this._productSku;
    }
    public set productSku(value: string) {
        this._productSku = value;
    }

    private _modalType: string = "standard";
    public get modalType(): string {
        return this._modalType;
    }
    public set modalType(value: string) {
        this._modalType = value;
    }

    private _productName: string = "";
    public get productName(): string {
        if (this.product.name) return this.product.name;

        return "";
    }
    public set productName(value: string) {
        this._productName = value;
    }

    public setProductToBuyInformation(sku: string) {
        this.productSku = sku;
        this.modalType = "yesno";
        this.buyAPI();
        // if(this.workspace.hasSomeProduct)
        // {
        //     this.modalType = "standard";
        // }
    }

    public get product(): Product {
        return this.workspace.appStoreProducts.filter(v => {
            return v.sku == this.productSku;
        })[0];
    }

    public activeProductForUser() {
        console.log(this.product.id);
        this.workspace.activateProductById(this.product.id, this.activeModal);
    }
}
